import { Navigate } from "react-router-dom";
export default function PrivateRoute({ children, roleAllowed }) {
    const role = localStorage.getItem("role");
    const token = localStorage.getItem("token");
    if (!role || !token || (roleAllowed && role !== roleAllowed)) return <Navigate to="/login" replace />;
    return children;
}
